<div class="mobile-content-container" #contentDiv>
  <app-welcome [class.page-hidden]="pageIndex !== 0"></app-welcome>
  <app-project-overview
    [class.page-hidden]="pageIndex !== 1"
  ></app-project-overview>
  <app-environmental [class.page-hidden]="pageIndex !== 2"></app-environmental>
  <app-traffic [class.page-hidden]="pageIndex !== 3"></app-traffic>
  <app-alternatives [class.page-hidden]="pageIndex !== 4"></app-alternatives>
  <app-public-comment
    [class.page-hidden]="pageIndex !== 5"
  ></app-public-comment>
</div>
